import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { SeriesTarget } from '@app/application/report/screens/graphs-echarts/types'

// Tracks which report rows are currently highlighted as a result of a graph
// metric click. A metric can reference several report elements (matched on
// data-identifier) and several accounts (matched on data-account-id), so this
// holds both lists. The Stimulus controller mounted on #report subscribes to
// them and applies the scroll + highlight to each matching <tr>.
export const useReportRowHighlight = defineStore('reportRowHighlight', () => {
  const identifiers = ref<string[]>([])
  const accountIds = ref<number[]>([])

  function highlight(target: SeriesTarget): void {
    // Copy so the store owns its state rather than aliasing the graph payload's
    // arrays (lookupSeriesTarget returns a live seriesTargets reference).
    identifiers.value = [...target.identifiers]
    accountIds.value = [...target.accountIds]
  }

  function clear(): void {
    identifiers.value = []
    accountIds.value = []
  }

  return { identifiers, accountIds, highlight, clear }
})
